module.exports = __webpack_public_path__ + "static/media/towers.8ab0c02b.jpg";